<app-badge [text]="'VIP'" [backgroundColor]="'var(--primary-y-yellow)'"></app-badge>
